import { Response, ResponseMeta } from '@/types/requests-types'
import { DEFAULT_ERROR_MESSAGE } from '@/helpers/requests/const'


/**
 * Represents a standard response error.
 * @class
 * @property message
 * @property status
 * @property meta
 */
export default class ResponseError extends Error {
    public message: string
    public status: number
    public meta: ResponseMeta|null

    constructor(message: string, status: number, meta: ResponseMeta|null) {
        super()
        this.message = message
        this.status = status
        this.meta = meta
    }

    static fromResponse(response: Response) {
        return new ResponseError(response.message, response.status, response.meta)
    }

    static fromUnhandled(): ResponseError {
        return new ResponseError(DEFAULT_ERROR_MESSAGE, 0, null)
    }
}
